import React from 'react';
import { useTranslation } from 'react-i18next';

import s from './RequiredMarker.scss';

const RequiredMarker: React.FC = () => {
  const { t } = useTranslation();
  return <div className={s['required']}>{t('common.required')}</div>;
};
RequiredMarker.displayName = 'RequiredMarker';

export default RequiredMarker;
